import React from "react";

import {
  ButtonIcon,
  Caption,
  Card,
  DetailedSubheading,
  Flex,
} from "@olist/design-system";
import { ExternalOutline } from "@olist/design-system-icons";

import { LinkButton } from "./styles";
import { TicketSuccess } from "icons/index";

export function SuccessStep({
  email,
  ticketId,
}: {
  email: string;
  ticketId: string;
}) {
  return (
    <Flex
      width="100%"
      justifyContent="center"
      height="100%"
      alignItems="center"
    >
      <Flex
        width="60%"
        justifyContent="center"
        flexDirection="column"
        gap="stack.large"
      >
        <Card>
          <Flex
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap="stack.medium"
            py="inset.medium"
            px="inline.large"
          >
            <img src={TicketSuccess} alt="imagem de sucesso" />
            <Flex
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
            >
              <DetailedSubheading>
                Seu chamado de suporte foi criado
              </DetailedSubheading>
              <Caption>
                Em breve nossa equipe irá te responder pelo email: {email}
              </Caption>
            </Flex>
            <LinkButton
              href={`/support/ticket/${ticketId}?form=case-${ticketId}&realm=tiny`}
              iconLeft={<ExternalOutline color="white" />}
            >
              <Caption color="white" bold>
                acompanhar chamado
              </Caption>
            </LinkButton>
          </Flex>
        </Card>

        <Flex gap="stack.small" flexDirection="column">
          <Caption>Você tambem pode:</Caption>
          <Card direction="row">
            <Flex
              justifyContent="space-between"
              padding="inset.small"
              width="100%"
            >
              <Flex flexDirection="column" gap="stack.2xsmall">
                <Caption bold>Acompanhar todos os meus chamados</Caption>
                <Caption>Acesse todos os seus chamados</Caption>
              </Flex>
              <ButtonIcon
                icon={<ExternalOutline />}
                onClick={() => {
                  window.location.assign("/support?realm=tiny");
                }}
              />
            </Flex>
          </Card>
          <Card direction="row">
            <Flex
              justifyContent="space-between"
              padding="inset.small"
              width="100%"
            >
              <Flex flexDirection="column" gap="stack.2xsmall">
                <Caption bold>Visitar a central de ajuda</Caption>
                <Caption>
                  Encontre artigos de ajuda sobre todas as ferramentas do
                  sistema
                </Caption>
              </Flex>
              <ButtonIcon
                icon={<ExternalOutline />}
                onClick={() => {
                  window.location.assign("/kb");
                }}
              />
            </Flex>
          </Card>
        </Flex>
      </Flex>
    </Flex>
  );
}
